<template>
  <one-column-layout :loading="isLoading" ref="page_scroll" class="dark space-l reports">
    <title-bar title="Reports"
               slot="titleBar"
               type="page"
               :class="{'persistent' : isScrolling}"
               :action-menu="!isDesktop"
               @menu="toggleNav">

      <div class="smd-spacer"/>
      <smd-segment type="pill solid"
                   :items="$options.Views" :value="activeView"
                   v-model="activeView"/>
    </title-bar>

    <div class="toolbar toolbar-reports" slot="subtitleBar" :class="{'persistent' : isScrolling}">
      <smd-options pilled normal bluebg tiny
                   v-if="activeView !== 'ReportTable'"
                   :items="$options.Filters"
                   :title="activeFilter.label"
                   @item-selected="updateFilter"/>
      <div class="form__row smd-date-range--reports">
        <label >FROM</label>
        <smd-date-input v-model="fromDate"/>
        <label >TO</label>
        <smd-date-input v-model="toDate"/>
      </div>

      <template v-if="activeView === 'ReportTable'">
        <div class="smd-spacer"></div>

        <label>Row</label>
        <select v-model="row">
          <option :value="category" v-for="category in listRowCategories" :key="category._id">{{category.label}}</option>
        </select>

        <label>Column</label>
        <select v-model="column">
          <option :value="category" v-for="category in listColumnCategories" :key="category._id">{{category.label}}</option>
        </select>

        <smd-btn icon="smd-icon-history"/>
      </template>
    </div>

    <div>
      <transition name="fade" :duration="{enter: 500, leave : 100}">
        <router-view :date-filter="getDateFilter"/>
      </transition>
    </div>
  </one-column-layout>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import scrollListener from '../../../mixins/scroll-listener'
  import uiHelper  from '../../../mixins/uihelper'
  import Routes from '../../../router/route-constants'
  import { mapProperties } from "../../../utilities/mappers";
  import {GETTER_TABLE_ROW_CATEGORY, GETTER_TABLE_COLUMN_CATEGORY,
    MUTATE_ROW_CATEGORY, MUTATE_COLUMN_CATEGORY} from "../../../store/modules/analytics-table";
  import {GETTER_CATEGORIES, ACTION_LOAD_CATEGORIES} from "../../../store/modules/categories";

  export default {
    name: "root-reports",
    mixins: [scrollListener, uiHelper],
    Views  :[
      {val: Routes.ROUTE_REPORT_SUMMARY, label: 'Summary'},
      {val: Routes.ROUTE_REPORT_TABLE  , label: 'Table'}
    ],
    Filters: [
      {val: 'obreport'          , label: 'OB Report'},
      {val: 'maternalMortality' , label: 'Maternal Mortality Report'},
    ],
    Quarters: [
      {val: '1st' , label: '1st'},
      {val: '2nd' , label: '2nd'},
      {val: '3rd' , label: '3rd'},
      {val: '4th' , label: '4th'}
    ],
    Years:[
      {val: 'more', label: '...'},
      {val: '2015', label: '2015'},
      {val: '2016', label: '2016'},
      {val: '2017', label: '2017'},
      {val: '2018', label: '2018'}
    ],
    watch:{
      'activeView'(newRoute){
        this.refreshRoute(newRoute, this.activeFilter);
      },
      'activeFilter'(newFilter){
        this.refreshRoute(this.activeView, newFilter);
      },
      'fromDate'(){
        this.refreshRoute(this.activeView, this.activeFilter);
      },
      'toDate'(){
        this.refreshRoute(this.activeView, this.activeFilter);
      },
      listRowCategories(newValue) {
        this.row = newValue[0];
      },
      listColumnCategories(newValue) {
        this.column = newValue[0];
      }
    },
    data(){
      return{
        activeFilter: this.$options.Filters[0],
        activeView : null,
        showDateFilter : false,
        isLoading: false,
        fromDate: new Date().setMonth(new Date().getMonth() - 3),
        toDate: new Date()
      }
    },
    computed: {
      ...mapGetters({
        categories: GETTER_CATEGORIES,
      }),
      ...mapProperties({
        row:{getter:GETTER_TABLE_ROW_CATEGORY, mutation: MUTATE_ROW_CATEGORY},
        column:{getter:GETTER_TABLE_COLUMN_CATEGORY, mutation: MUTATE_COLUMN_CATEGORY}
      }),
      listRowCategories() {
        return this.categories
      },
      listColumnCategories() {
        return [{_id:0, name:"NA",label:"N/A"}].concat(this.categories)
      },
      getDateFilter() {
        return {from: new Date(this.fromDate), to: new Date(this.toDate) }
      },
      isDesktop(){
        return this.$mq.desktop;
      }
    },
    methods:{
      ...mapActions({
        getCategories : ACTION_LOAD_CATEGORIES
      }),
      updateFilter(item){
        this.activeFilter = item;
      },
      refreshRoute(route, filter){
        this.$router.push({
          name: route,
          params:{
            filterBy: filter.val,
            filterDateFrom: this.fromDate,
            filterDateTo  : this.toDate
          }
        });

        this.isLoading = false;
      }
    },
    mounted(){
      this.getCategories();
      this.activeView = Routes.ROUTE_REPORT_SUMMARY;
      this.isLoading = true;
    }
  }
</script>

<style lang="scss">

  @import '../../../scaffolding/scss/pogs-util';

  .toolbar-reports{
    .smd-options > button{
      text-align: unset;
      min-width: 190px;
      span{
        float: right;
      }
    }

    label + select{
      margin: 0 space(s);
    }

    select{
      min-width: 240px;
      background: white;
    }
  }

  @include responsive(mobile) {
    .smd-date-range--reports, .toolbar-reports {
      display: none !important;
    }
    .reports-panel .content {
      overflow: auto !important;
    }
  }

  .reports {
    overflow: auto;
  }
</style>